import { __awaiter } from "tslib";
import { useEffect } from 'react';
import { default as consoleEvents } from "@pb/utils/consoleEvents";
function ScriptLoader({ scripts, importantScriptIndex, articleId, batchIdentifier, }) {
    useEffect(() => {
        const loadScript = (script, sequenceNumber) => {
            return new Promise((resolve, reject) => {
                const scriptElement = document.createElement('script');
                const scriptId = `${batchIdentifier}-${articleId}-${sequenceNumber}`;
                scriptElement.id = scriptId;
                if (script.url) {
                    // Load external script
                    scriptElement.src = script.url;
                    scriptElement.onload = resolve;
                    scriptElement.onerror = reject;
                }
                else if (script.content) {
                    // Execute inline script
                    scriptElement.textContent = script.content;
                    resolve(undefined);
                }
                else {
                    reject(new Error('Invalid script format'));
                }
                document.body.appendChild(scriptElement);
            });
        };
        // Load scripts sequentially, ensuring the important script is loaded first
        const loadScriptsSequentially = () => __awaiter(this, void 0, void 0, function* () {
            let sequenceNumber = importantScriptIndex !== undefined ? 1 : 0;
            // Load important script first
            if (importantScriptIndex !== undefined &&
                importantScriptIndex >= 0 &&
                importantScriptIndex < scripts.length) {
                try {
                    yield loadScript(scripts[importantScriptIndex], 0);
                }
                catch (error) {
                    consoleEvents.error('Error loading important script:', error);
                    return;
                }
            }
            // Load the rest of the scripts
            for (let i = 0; i < scripts.length; i += 1) {
                if (i !== importantScriptIndex) {
                    loadScript(scripts[i], (sequenceNumber += 1)).catch((error) => {
                        consoleEvents.error('Error loading script:', error);
                    });
                }
            }
        });
        // Start loading scripts when the component mounts
        Promise.all(scripts.map((script, sequenceNumber) => {
            return loadScript(script, sequenceNumber).catch((error) => {
                consoleEvents.error('Error loading script:', error);
            });
        })).then(() => {
            // console.log('All scripts loaded');
            loadScriptsSequentially();
        });
        // Cleanup function on component unmount
        return () => {
            // Remove dynamically added script elements from the DOM
            scripts.forEach((_, sequenceNumber) => {
                const scriptId = `${batchIdentifier}-${articleId}-${sequenceNumber}`;
                const scriptElement = document.getElementById(scriptId);
                if (scriptElement) {
                    scriptElement.remove();
                }
            });
        };
    }, [scripts, importantScriptIndex, articleId]);
    return null; // Since this is a utility component, it doesn't render anything
}
export default ScriptLoader;
//# sourceMappingURL=ScriptLoader.js.map